<style scoped>
.excel-span {
  height: 24px;
  line-height: 24px;
  display: inline-block;
  padding: 1px 8px 1px 8px;
  border-radius: 4px;
  background-color: #f4f4f5;
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
</style>
<template>
  <div>
    <el-dialog :visible.sync="visible" :title="title" append-to-body="append-to-body">
      <div :class="[tableData.length > 0 ? 'dialog-scroller' : '']" style="display: flex;flex-direction: column;">
        <!--上传-->
        <div>
          <input id="matterFileInput" ref="excel-upload-input" class="excel-upload-input" type="file" multiple accept=".xlsx, .xls" @change="handleClick" />
          <el-button size="mini" type="primary" icon="el-icon-document-add" @click="exportModel">
            {{ $t('xiazaimuban') }}
          </el-button>
          <el-button :loading="loading" size="mini" type="default" icon="el-icon-plus" @click="handleUpload">
            {{ $t('piliangshangchuan') }}
          </el-button>
        </div>
        <!--excel-->
        <div style="margin-top: 10px">
          <span v-for="(item, index) in excel" :key="index" class="excel-span" closable size="mini">
            <i class="el-icon-link" />
            <span>{{ item }}</span>
            <i style="margin-left: 5px" class="el-icon-close" @click="deleteExcel(item)" />
          </span>
        </div>
        <!--表格-->
        <div ref="table" style="flex: 1;margin-top: 10px;">
          <el-table stripe :max-height="tableHeight" :data="tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)" border size="mini" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
            <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop" :show-overflow-tooltip="true" :label="item.label" :width="item.width" :sortable="item.sortable">
              <template slot-scope="scope">
                <span>{{ scope.row[item.prop] === '' ? '-' : scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 20px;">
          <el-pagination v-if="tableData.length > 0" style="display: flex;float: right;" background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :pagerCount="5" :page-size="pagination.pageSize" layout="total,sizes,prev,pager,next" :total="tableData.length" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="visible = false">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" size="mini" :loading="importLoading" @click="importData" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '物料检验标准-导入物料检验标准' } }">{{ $t('baocun')
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: ['show', 'inspectionStandardId'],
  data() {
    return {
      loading: false,
      importLoading: false,
      listLength: '',
      excel: [],
      tableHeight: 0,
      tableData: [],
      tableColumn: [
        {
          label: this.$t('daorubaogao'),
          prop: 'result',
          width: 125,
        },
        {
          label: this.$t('jianyanbiaozhunmingcheng'),
          sortable: true,
          prop: 'name',
          width: 125
        },
        {
          label: this.$t('jianyanleixing'),
          sortable: true,
          prop: 'inspectionType',
          width: 125
        },
        {
          label: this.$t('chanpinbianma'),
          sortable: true,
          prop: 'materialCode',
          width: 125
        },
        {
          label: this.$t('shifoudaorufenleijianyanbiaozhun'),
          sortable: true,
          prop: 'importClassificationStandardText',
          width: 180
        }, {
          label: this.$t('fenleijianyanbiaozhunmingcheng'),
          sortable: true,
          prop: 'classificationStandardName',
          width: 180
        },
        {
          label: this.$t('gongxu'),
          prop: 'procedure',
          sortable: true,
          width: 125
        },
        {
          label: this.$t('jianyanleibie'),
          prop: 'category',
          sortable: true,
          width: 130
        },
        {
          label: this.$t('jianyanxiangmu'),
          prop: 'item',
          sortable: true,
          width: 150
        },
        {
          label: this.$t('jianyangongju'),
          prop: 'tool',
          sortable: true,
          width: 150
        },
        {
          label: this.$t('jianyanbiaoshi'),
          prop: 'flag',
          sortable: true,
          width: 150
        },
        {
          label: this.$t('jianyanfangshi'),
          prop: 'inspectionMethodCode',
          sortable: true,
          width: 120
        },
        {
          label: this.$t('shifoubijian'),
          prop: 'necessity',
          sortable: true,
          width: 140
        },
        {
          label: this.$t('jianyanyiju'),
          prop: 'basis',
          sortable: true,
          width: 150
        },
        {
          label: this.$t('quexiandengji'),
          prop: 'defectLevel',
          sortable: true,
          width: 150
        },
        {
          label: this.$t('chouyangguocheng'),
          prop: 'samplingProcedureCode',
          sortable: true,
          width: 150
        },
        {
          label: this.$t('guigexiaxian'),
          prop: 'specMin',
          sortable: true,
          width: 150
        },
        {
          label: this.$t('guigeshangxian'),
          prop: 'specMax',
          sortable: true,
          width: 150
        },
        {
          label: this.$t('jiliangdanwei'),
          prop: 'unit',
          sortable: true,
          width: 150
        }
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      visible: false,
      title: this.$t('daoru')
    };
  },
  watch: {
    show: {
      handler(n) {
        this.visible = n;
        if (n == true) {
          this.countTableHeight();
        }
        if (n == false) {
          this.currentPage = 1;
        }
      },
      immediate: false
    },
    visible: {
      handler(n) {
        if (!n) {
          this.$emit('update:show', false);
          this.tableData = [];
          this.excel = [];
          this.$refs['excel-upload-input'].value = null;
        }
      },
      immediate: false
    }
  },
  mounted() { },
  methods: {
    countTableHeight() {
      this.tableHeight = 0;
      this.$nextTick(() => {
        if (this.tableData.length > 0) {
          this.tableHeight = this.$refs.table.offsetHeight - 10;
        } else {
          this.tableHeight = 110;
        }
      });
    },
    //深拷贝
    deepClone(data) {
      const type = this.judgeType(data);
      let obj;
      if (type === 'array') {
        obj = [];
      } else if (type === 'object') {
        obj = {};
      } else {
        // 不再具有下一层次
        return data;
      }
      if (type === 'array') {
        // eslint-disable-next-line
        for (let i = 0, len = data.length; i < len; i++) {
          obj.push(this.deepClone(data[i]));
        }
      } else if (type === 'object') {
        // 对原型上的方法也拷贝了....
        // eslint-disable-next-line
        for (const key in data) {
          obj[key] = this.deepClone(data[key]);
        }
      }
      return obj;
    },
    judgeType(obj) {
      // tostring会返回对应不同的标签的构造函数
      const toString = Object.prototype.toString;
      const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
      };
      if (obj instanceof Element) {
        return 'element';
      }
      return map[toString.call(obj)];
    },
    exportModel() {
      window.open((process.env.NODE_ENV === 'development' ? global.URL_DEV_API_BASE_DOMAIN : process.env.VUE_APP_SERVER === 'preview' ? global.URL_PRE_API_BASE_DOMAIN : global.URL_PROD_API_BASE_DOMAIN) + '/web/customer/files/viewFileByFileId/wuliaojianyanbiaozhundaorumuban');
    },
    importData() {
      const data = this.deepClone([...this.tableData]);
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      this.importLoading = true;
      for (let i = 0; i < data.length; i++) {
        // if (data[i]['necessityText'] == this.$t('shi')) {
        //   data[i]['necessity'] = 1;
        // }
        // if (data[i]['necessityText'] == this.$t('fou')) {
        //   data[i]['necessity'] = 0;
        // }
        // if (data[i]['flagText'] == this.$t('dingxing')) {
        //   data[i]['flag'] = 1;
        // }
        // if (data[i]['flagText'] == this.$t('dingliang')) {
        //   data[i]['flag'] = 2;
        // }
        if (data[i]['importClassificationStandardText'] == this.$t('shi')) {
          data[i]['importClassificationStandard'] = 1;
        }
        if (data[i]['importClassificationStandardText'] == this.$t('fou')) {
          data[i]['importClassificationStandard'] = 0;
        }
        // if( data[i]['defectLevelText'] ==this.$t('qingweiquexian')){
        //   data[i]['defectLevel'] =1
        // }
        // if( data[i]['defectLevelText'] ==this.$t('yibanquexian')){
        //   data[i]['defectLevel'] =2
        // }
        // if( data[i]['defectLevelText'] ==this.$t('yanzhongquexian')){
        //   data[i]['defectLevel'] =3
        // }
        // if( data[i]['defectLevelText'] ==this.$t('zhimingquexian')){
        //   data[i]['defectLevel'] =4
        // }
        delete data[i]['excel'];
      }
      if (this.listLength == null || this.listLength.length == 0) {
        return this.http
          .post('/web/quality/inspection/standard/batchImport?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.show = false;
            this.importLoading = false;
            // 刷新主页面列表(参数要与被调用得页面$on()中名称对应)
            this.utils.event_hub.$emit('STANDARDS_LIST_REFRESH');
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
            this.importLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
        this.importLoading = false;
      }
    },
    /**
     * 数据解析
     * @param header
     * @param results
     * @param name
     */
    generateData({ header, results, name }) {
      const data = [];
      if (results.length > 0) {
        for (let i = 0; i < results.length; i++) {
          const item = {
            excel: name
          };
          for (let j = 0; j < this.tableColumn.length; j++) {
            if (results[i][this.tableColumn[j]['label']] !== undefined && results[i][this.tableColumn[j]['label']] !== '') {
              this.$set(item, this.tableColumn[j]['prop'], results[i][this.tableColumn[j]['label']]);
            }
          }
          data.push(item);
        }
      }
      this.tableData = this.tableData.concat(data);
      this.excel.push(name);
      this.countTableHeight();
    },
    /**
     * 显示上传弹框
     */
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    /**
     * 点击上传
     * @param e
     * @returns {Promise<void>}
     */
    async handleClick(e) {
      this.importLoading = true;
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        this.beforeUpload(files[i]);
      }

      document.getElementById('matterFileInput').value = '';
      setTimeout(() => {
        let data = [...this.tableData];
        for (let i = 0; i < data.length; i++) {
          // if (data[i]['necessityText'] == this.$t('shi')) {
          //   data[i]['necessity'] = 1;
          // }
          // if (data[i]['necessityText'] == this.$t('fou')) {
          //   data[i]['necessity'] = 0;
          // }
          // if (data[i]['flagText'] == this.$t('dingxing')) {
          //   data[i]['flag'] = 1;
          // }
          // if (data[i]['flagText'] == this.$t('dingliang')) {
          //   data[i]['flag'] = 2;
          // }
          if (data[i]['importClassificationStandardText'] == this.$t('shi')) {
            data[i]['importClassificationStandard'] = 1;
          }
          if (data[i]['importClassificationStandardText'] == this.$t('fou')) {
            data[i]['importClassificationStandard'] = 0;
          }
          // if( data[i]['defectLevelText'] ==this.$t('qingweiquexian')){
          //   data[i]['defectLevel'] =1
          // }
          // if( data[i]['defectLevelText'] ==this.$t('yibanquexian')){
          //   data[i]['defectLevel'] =2
          // }
          // if( data[i]['defectLevelText'] ==this.$t('yanzhongquexian')){
          //   data[i]['defectLevel'] =3
          // }
          // if( data[i]['defectLevelText'] ==this.$t('zhimingquexian')){
          //   data[i]['defectLevel'] =4
          // }
          delete data[i]['result'];
          delete data[i]['excel'];
        }
        this.http
          .post('/web/quality/inspection/standard/batchImport?onlyValidate=true', data)
          .then(response => {
            // console.log('response', response.data)
            this.listLength = response.data.validateItems;
            if (response.data.validateItems && response.data.validateItems.length > 0) {
              const list = response.data.validateItems;
              for (let i = 0; i < list.length; i++) {
                this.$set(this.tableData[Number(list[i]['index'])], 'result', list[i]['items'].join(','));
              }
            }
            this.importLoading = false;
          })
          .catch(error => {
            this.utils.errorMessage(this.$t(error));
            this.importLoading = false;
          });
      }, 800);
    },
    /**
     * 上传前
     * @param rawFile
     * @returns {boolean}
     */
    beforeUpload(rawFile) {
      if (this.excel.length < 2) {
        //this.$refs['excel-upload-input'].value = null
      }
      if (!this.isExcel(rawFile)) {
        this.$message.error(this.$t('zhizhichi') + '.xlxs,xls,csv' + this.$t('geshiwenjian'));
        return false;
      }
      if (this.excel.length > 2) {
        this.$message.error(this.$t('zuidazhichi') + '3' + this.$t('geexcelwenjian'));
        return false;
      }
      if (this.excel.includes(rawFile.name)) {
        this.$message.error(rawFile.name + this.$t('wenjianyicunzai'));
        return false;
      }
      this.readerData(rawFile);
    },

    /**
     * 解析excel
     * @param rawFile
     */
    readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = e => {
        const name = rawFile.name;
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: 'array'
        });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const header = this.getHeaderRow(worksheet);
        const results = XLSX.utils.sheet_to_json(worksheet);
        this.generateData({
          header,
          results,
          name
        });
      };
      reader.readAsArrayBuffer(rawFile);
    },
    /**
     * 获取excel头部
     * @param sheet
     * @returns {[]}
     */
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet['!ref']);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell =
          sheet[
          XLSX.utils.encode_cell({
            c: C,
            r: R
          })
          ];
        let hdr = 'UNKNOWN ' + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * 判断是否为excel文件
     * @param file
     * @returns {boolean}
     */
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    },
    /**
     * 刪除excel
     * @param name
     */
    deleteExcel(name) {
      this.excel = this.excel.filter(item => {
        return item !== name;
      });
      this.tableData = this.tableData.filter(item => {
        return item.excel !== name;
      });
      console.log('excel:', this.excel);
      console.log('tableData:', this.tableData);
      console.log('tableColumn', this.tableColumn);
    }
  }
};
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}

.drop {
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
